import { useState } from "react";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean"
import { _PaymentFiles, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import { YearSelector } from "../../../../../../core/shared/inputs/YearSelector";
import { SelectMonths } from "../../../../../contract/select/SelectMonths";
import { BasicPage } from "../../../../../theme/Component/BasicPage";
import { BasicTable, MASK_NUMBER } from "../../../../../theme/Component/BasicTable";
import useModal, { MODAL_md, MODAL_SM, MODAL_XL } from "../../../../../theme/Component/hooks/useModal";
import { Modal } from "../../../../../theme/Component/Modal";
import { FileInput } from "../../../../../theme/Component/FileInput";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { ListMenu } from "../../../../../theme/Component/ListMenu";
import { toast } from "react-toastify";
import { DropDown } from "../../../../../theme/Component/DropDown";
import { ReportPaymentFiles } from "./ProcesosComponents/ReportPaymentFiles";

export const PaymentFiles = () => {

    const _paymentFiles = useDataBean(_PaymentFiles);
    const { bean, setBean, lista, setLista, instance, handleChange } = _paymentFiles;
    const modalEdit = useModal("Editar", MODAL_md);
    const modalReporte = useModal("Reporte", MODAL_XL);
    const modalDel = useModal("Eliminar", MODAL_SM);

    const [filter, setFilter] = useState<any>({
        Year: _single.getCurrenYear(),
        Month: _single.getCurrentMonth()
    });

    const makePeriodo = (year: number, month: number) => {
        month = month + 1;
        const periodo = year + "" + ((month < 10) ? '0' + month : '' + month);
        return periodo;

    }
    const periodo = makePeriodo(filter.Year, filter.Month);

    const getList = () => {
        _paymentFiles.getLista({ Periodo: periodo }, null);
    }


    const agregar = () => {
        setBean({
            Periodo: periodo,
            IDEmployee: _single.getAccountID()
        })
        modalEdit.open();
    }


    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: () => agregar() }
    ]

    const head = [
        { title: 'ID', property: 'IDPaymentFiles', visible: true, mask: MASK_NUMBER },
        { title: 'Periodo', property: 'Periodo', visible: true, mask: MASK_NUMBER },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Archivo', property: 'Media', visible: true },
        { title: 'Fecha', property: 'Since', visible: true },
        { title: 'Fecha Reporte', property: 'LastUpdate', visible: true }
    ]

    const addItem = () => {
        console.log(bean);
        _paymentFiles.update().then(
            (resp: any) => {
                getList();
                modalEdit.close();
            }
        )

    }
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: true, evento: () => { modalEdit.open() } },
            { titulo: 'Generar Reporte', icono: 'ri-database-2-line', visible: true, evento: () => { reporteRecaudo() } },
            { titulo: 'Ver Reporte', icono: 'ri-file-list-line', visible: true, evento: () => { modalReporte.open() } },
            { titulo: 'Eliminar', icono: 'ri-eraser-line', visible: true, evento: () => { modalDel.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const reporteRecaudo = () => {
        const filtro = {
            IDEmployee: _single.getAccountID()
        }
        _paymentFiles.instance.reportPaymentFiles(bean.IDPaymentFiles, filtro).then(
            (resp: any) => {
                console.log(resp);
                toast.success("Se esta generando el reporte sera notificado al terminar");

            }
        )
    }


    const consolidarReport = () => {
        const filtro = {
            IDEmployee: _single.getAccountID(),
            Periodo: periodo ? parseInt(periodo) : null
        }
        _paymentFiles.instance.reportPaymentByPeriodo(null, filtro).then(
            (resp: any) => {

                toast.success("Se esta generando el reporte sera notificado al terminar");

            }
        )
    }
    const eliminarFile = () => {
        instance.delete(bean.IDPaymentFiles).then(
            (resp: any) => {
                getList();
                modalDel.close();
            }
        );
    }

    const actionsDropDown = [
        { id: 1, name: 'Consolidar Archivos', permiso: null, activo: true },

    ];
    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    {periodo &&
                        <DropDown lista={actionsDropDown} eventClick={(e) => {
                            if (e.id === 1) {
                                consolidarReport();
                            }
                        }}></DropDown>

                    }
                </div>
            </div>
        )
    }

    return (
        <BasicPage titulo="Archivos Recaudo">
            <div className="row">
                <div className="col-md-3">
                    <YearSelector tittle="Año" value={filter.Year} onChange={(e) => { setFilter({ ...filter, "Year": e }) }} />
                </div>
                <div className="col-md-3">
                    <SelectMonths label="Mes" idSelector={filter.Month} onChange={(e) => { setFilter({ ...filter, "Month": e }) }} />
                </div>
                <div className="col-md-3">
                    <BasicButton useMargin icon="" eventClick={getList}>Buscar</BasicButton>
                </div>
                <div className="col-md-12">
                    <h6>Periodo : {periodo}</h6>
                    <BasicTable headButtons={buttons()} body={lista} head={head} rowSet={setBean} iconButtons={iconButtonsItem} listButtons={listaBotones()} />


                    <Modal modal={modalEdit.modal} updateModal={modalEdit.setModal} eventModal={addItem}>
                        <div className="row">

                            <div className="col-md-12">
                                <FileInput Media={bean.Media} MediaContext={bean.MediaContext} directory="paymentsfiles" onCreate={(e) => { setBean({ ...bean, "Media": e.Media, "MediaContext": e.MediaContext }) }} />
                            </div>
                            <div className="col-md-12">
                                <label>Observación</label>
                                <textarea name="Description" id="Description" value={bean.Description} onChange={handleChange} className="form-control"></textarea>
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalReporte.modal} updateModal={modalReporte.setModal}>
                        <div className="row">
                            <div className="col-md-12">
                                <ReportPaymentFiles idPaymentFiles={bean.IDPaymentFiles} />
                            </div>
                            {/* <div className="col-md-12">
                                {bean.ReportUrl ?
                                    <div>
                                        <strong>Fecha reporte : </strong> {bean.LastUpdate}
                                        <hr />
                                        <a href={bean.ReportUrl} target="_blank">Descargar</a>
                                    </div>
                                    :
                                    <>
                                        <strong>No se ha generado un reporte</strong>
                                    </>
                                }
                            </div> */}
                        </div>
                    </Modal>
                    <Modal modal={modalDel.modal} updateModal={modalDel.setModal} eventModal={eliminarFile}>
                        Eliminar archivo
                    </Modal>
                </div>
            </div>
        </BasicPage>
    )
}